import { render, staticRenderFns } from "./TagsSection.vue?vue&type=template&id=3edbfe16&scoped=true"
import script from "./TagsSection.vue?vue&type=script&lang=js"
export * from "./TagsSection.vue?vue&type=script&lang=js"
import style0 from "./TagsSection.vue?vue&type=style&index=0&id=3edbfe16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edbfe16",
  null
  
)

export default component.exports